import React, { useState, useEffect, useRef } from 'react';
import './home.css';
import AboutMeImage from './Media/AboutMePreview.png';
import Oracle811Badge from './Media/Oracle811Badge.jpg';
import Oracle808Badge from './Media/Oracle808Badge.png';
import Contact from './contact';
import ResumePopup from './resumerequest';
import DisableDevtool from 'disable-devtool';

DisableDevtool();
// test comment

function Home() {
  const [language, setLanguage] = useState('en');
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [showResumePopup, setShowResumePopup] = useState(false);
  const [clicked, setClicked] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [visibleSections, setVisibleSections] = useState({
    introduction: false,
    skills: false,
    experience: false,
    certifications: false,
    works: false,
    languages: false,
    aboutMe: false
  });

  //Some crazy shit idk - HELLO?

  // Refs for sections to track visibility
  const introductionRef = useRef(null);
  const skillsRef = useRef(null);
  const experienceRef = useRef(null);
  const certificationsRef = useRef(null);
  const worksRef = useRef(null);
  const languagesRef = useRef(null);
  const aboutMeSectionRef = useRef(null);
  const aboutImageRef = useRef(null); // Added ref for the flip card with your picture

  const handleClick = (index) => {
    setClicked(clicked === index ? null : index);
  };

  const handleContactClick = () => {
    setShowContactPopup(true);
  };

  const closeContactPopup = () => {
    setShowContactPopup(false);
  };

  const handleResumeClick = () => {
    setShowResumePopup(true);
  };

  const closeResumePopup = () => {
    setShowResumePopup(false);
  };

  // Function to check if an element is in viewport
  const isInViewport = (element, offset = 100) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= window.innerHeight - offset &&
      rect.bottom >= offset
    );
  };

  // Scroll listener effect
  useEffect(() => {
    const handleScroll = () => {
      // Update scroll position
      setScrollPosition(window.scrollY);
      
      // Check if each section is visible
      setVisibleSections({
        introduction: isInViewport(introductionRef.current),
        skills: isInViewport(skillsRef.current),
        experience: isInViewport(experienceRef.current),
        certifications: isInViewport(certificationsRef.current),
        works: isInViewport(worksRef.current),
        languages: isInViewport(languagesRef.current),
        aboutMe: isInViewport(aboutMeSectionRef.current)
      });

      // Navbar background change
      const navbar = document.querySelector('.Navbar');
      const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
    
      if (scrollPercentage >= 5) {
        navbar.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
        navbar.style.backdropFilter = 'blur(10px)';
        navbar.style.boxShadow = '0 4px 30px rgba(0, 0, 0, 0.1)';
      } else {
        navbar.style.backgroundColor = 'rgba(34, 34, 34, 0)';
        navbar.style.backdropFilter = 'none';
        navbar.style.boxShadow = 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Initial check for visible sections
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (ref) => {
    if (ref.current) {
      // Get the element's position
      const yPosition = ref.current.getBoundingClientRect().top + window.pageYOffset;
      
      // Subtract a fixed offset (adjust the 80 value based on your navbar height plus desired padding)
      const offsetPosition = yPosition - 50;
      
      // Scroll to the adjusted position
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleRedirectDE = () => {
    window.location.href = '/de'; // Redirect to the German version of the site
  };

  // Parallax effect for the about section
  const parallaxOffset = scrollPosition * 0.3;

  return (
    <div className="home-container">
      <div className='Navbar'>
        <div className='nav-button-container'>
          <h1 className='Name-Top-Left'>Ron <span className="name" id='topnameclick'onClick={() => scrollToSection(aboutImageRef)}>Ellrich</span></h1>
          <div className="nav-links">
            <button className='nav-button' onClick={handleContactClick}>Contact</button>
            <button className='nav-button' onClick={() => scrollToSection(worksRef)}>Works</button>
            <button className='nav-button' onClick={handleResumeClick}>Resume</button>
            <button className='nav-button' onClick={handleRedirectDE}>Language</button>
          </div>
        </div>
      </div>

      <div className="hero-section" style={{ transform: `translateY(${parallaxOffset}px)` }}>
        <div className="hero-content">
          <h1 className="hero-title">Fullstack Developer <br></br>&<br></br> Visual Thinker</h1>
          <p className="hero-subtitle">Shaping interfaces, sharpening pixels</p>
        </div>
      </div>

      <div className="about-section">
        <div className={`flip-card ${scrollPosition > 100 ? 'animate-in' : ''}`} ref={aboutImageRef}>
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <img src={AboutMeImage} alt="Ron Ellrich" />
            </div>
            <div className="flip-card-back">
              <h2>Ron Ellrich</h2>
              <p>Transforming ideas into contracts,<br />and contracts into code.</p>
              <p>Code with Style • Design with Heart</p>
              <p>Based in Germany - Working Worldwide</p>
              <p>☕ Coffee. ⌨ Code. 🧠 Design.</p>
            </div>
          </div>
        </div>

        <div 
          className={`Introduction ${visibleSections.introduction ? 'fade-in visible' : 'fade-in'}`} 
          ref={introductionRef}
        >
          <h2>
            Hello, I'm <span className="name">Ron Ellrich</span>, UX/UI Designer and <br />
            Fullstack Developer Based in Germany.
          </h2>
        </div>

        <div 
          className={`Lebenslauf Skills ${visibleSections.skills ? 'fade-in visible' : 'fade-in'}`} 
          ref={skillsRef}
          id='TOP'
        >
          <h2 className="section-title">SKILLS</h2>
          <ul className="animated-list">
            <li 
              onClick={() => handleClick(0)} 
              className={`list-item ${clicked === 0 ? 'expanded' : ''}`}
            >
              {clicked === 0 ? (
                <div className="expanded-content">
                  <span>JavaScript, HTML5, and CSS3 are used together to build interactive, visually appealing, and responsive websites and web applications...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">JavaScript</span> | <span className="highlight">HTML5</span> | <span className="highlight">CSS3</span> • Frontend Development
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(1)} 
              className={`list-item ${clicked === 1 ? 'expanded' : ''}`}
            >
              {clicked === 1 ? (
                <div className="expanded-content">
                  <span>My current 'go-to' When it comes to Web-Development. I love the flexibility and the power of React...
                  </span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">React</span> • Frontend Framework
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(16)} 
              className={`list-item ${clicked === 16 ? 'expanded' : ''}`}
            >
              {clicked === 16 ? (
                <div className="expanded-content">
                  <span>Java is used for enterprise software, mobile app development, web apps, cloud-based applications, games, and IoT applications...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <div className='Oracle808Badge'> <img src={Oracle808Badge} alt="Oracle Badge"/></div>
                  <div className='Oracle811Badge'> <img src={Oracle811Badge} alt="Oracle Badge"/></div>
                  <span className="highlight">Java</span> • Backend Development
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(21)} 
              className={`list-item ${clicked === 21 ? 'expanded' : ''}`}
            >
              {clicked === 21 ? (
                <div className="expanded-content">
                  <span>C# is used for enterprise software, desktop and web apps, game development, and cloud/Windows-based applications...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">C#</span> • Backend Development
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(2)} 
              className={`list-item ${clicked === 2 ? 'expanded' : ''}`}
            >
              {clicked === 2 ? (
                <div className="expanded-content">
                  <span>Python is used for backend development, databases, analysis, processing and more...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Python</span> • Backend Development
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(22)} 
              className={`list-item ${clicked === 22 ? 'expanded' : ''}`}
            >
              {clicked === 22 ? (
                <div className="expanded-content">
                  <span>Spring Boot is used for building enterprise-grade backend systems, REST APIs, microservices, and cloud-based applications...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Spring Boot (Java)</span> • Backend Framework
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(23)} 
              className={`list-item ${clicked === 23 ? 'expanded' : ''}`}
            >
              {clicked === 23 ? (
                <div className="expanded-content">
                  <span>.NET is a cross-platform developer platform by Microsoft for building web, mobile, desktop, gaming, and IoT applications...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">.NET (C#)</span> • Development Platform
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(3)} 
              className={`list-item ${clicked === 3 ? 'expanded' : ''}`}
            >
              {clicked === 3 ? (
                <div className="expanded-content">
                  <span>DjangoDB is used for building web applications with a focus on backend development using SQL databases...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">DjangoDB (SQL | Python)</span> • Backend Framework
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(18)} 
              className={`list-item ${clicked === 18 ? 'expanded' : ''}`}
            >
              {clicked === 18 ? (
                <div className="expanded-content">
                  <span>MySQL is a relational database management system used to store, manage, and query structured data using SQL for various applications....</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">MySQL</span> • Database Management System
                </div>
              )}
            </li>
          </ul>
        </div>

        <div 
          className={`Lebenslauf Experience ${visibleSections.experience ? 'fade-in visible' : 'fade-in'}`}
          ref={experienceRef}
        >
          <h2 className="section-title">EXPERIENCE</h2>
          <ul className="animated-list">
            <li 
              onClick={() => handleClick(19)} 
              className={`list-item ${clicked === 19 ? 'expanded' : ''}`}
            >
              {clicked === 19 ? (
                <div className="expanded-content">
                  <span>Undergoing postgraduate training as a software developer with a focus on Java and C# to further expand my tech stack...</span>
                  <button className='Detail-Button' onClick={() => window.open('https://smartfuturecampus.de', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Postgraduate training as Software Developer - Java / C#</span> at Smart Future Campus GmbH 2025 - 2026
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(4)} 
              className={`list-item ${clicked === 4 ? 'expanded' : ''}`}
            >
              {clicked === 4 ? (
                <div className="expanded-content">
                  <span>Experience as a Customer Success Manager at PAYZN GmbH, focusing on customer relationships...</span>
                  <button className='Detail-Button' onClick={() => window.open('https://payzn.de', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Customer Success Manager</span> at PAYZN GmbH 2025 - 2025
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(5)} 
              className={`list-item ${clicked === 5 ? 'expanded' : ''}`}
            >
              {clicked === 5 ? (
                <div className="expanded-content">
                  <span>Hotel Management Expert Trainee at Küstenperle Strandhotel & Spa, assisting in hotel operations...</span>
                  <button className='Detail-Button' onClick={() => window.open('https://www.hotel-kuestenperle.de', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Hotel Management Expert Trainee</span> at Küstenperle Strandhotel & Spa 2021 - 2024
                </div>
              )}
            </li>
          </ul>

          <h2 
            className={`section-title ${visibleSections.certifications ? 'fade-in visible' : 'fade-in'}`}
            ref={certificationsRef}
          >
            CERTIFICATIONS
          </h2>
          <ul className="animated-list">
            <li 
              onClick={() => handleClick(20)} 
              className={`list-item ${clicked === 20 ? 'expanded' : ''}`}
            >
              {clicked === 20 ? (
                <div className="expanded-content">
                  <span>Industry-recognized certification demonstrating proficiency in core Java programming, object-oriented principles, and practical software development skills.</span>
                  <button className='Detail-Button' onClick={() => window.open('https://education.oracle.com/oracle-certified-associate-java-se-8-programmer/trackp_333', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <div className='Oracle808BadgeCertificate'> <img src={Oracle808Badge} alt="Oracle Badge"/></div>
                  <span className="highlight">Oracle Certified Associate, Java SE 8 Programmer</span>, ORACLE - 2025
                </div>
              )}
            </li>
             <li 
              onClick={() => handleClick(15)} 
              className={`list-item ${clicked === 15 ? 'expanded' : ''}`}
            >
              {clicked === 15 ? (
                <div className="expanded-content">
                  <span>Industry-recognized certification demonstrating foundational skills in Java, OOP, and software development. </span>
                  <button className='Detail-Button' onClick={() => window.open('https://education.oracle.com/oracle-certified-foundations-associate-java/trackp_372', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <div className='Oracle811Badge'> <img src={Oracle811Badge} alt="Oracle Badge"/></div>
                  <span className="highlight">Java Certified Foundations Associate</span>, ORACLE - 2025
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(17)} 
              className={`list-item ${clicked === 17 ? 'expanded' : ''}`}
            >
              {clicked === 17 ? (
                <div className="expanded-content">
                  <span>State recognized Professional Competence within the Digital fields of IT, through the German Chamber of Commerce and Industry </span>
                  <button className='Detail-Button' onClick={() => window.open('https://www.dihk-bildungs-gmbh.de/weiterbildung/ihk-zertifikate/zertifikatslehrgaenge/digitale-kompetenz-im-job-ihk', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Professional Digital Competence</span>, IHK - 2025
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(6)} 
              className={`list-item ${clicked === 6 ? 'expanded' : ''}`}
            >
              {clicked === 6 ? (
                <div className="expanded-content">
                  <span>State recognized Hotel Management Expert, through the German Chamber of Commerce and Industry</span>
                  <button className='Detail-Button' onClick={() => window.open('https://web.arbeitsagentur.de/berufenet/beruf/10009#ueberblick', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Hotel Management Expert</span>, Küstenperle Strandhotel & Spa - 2024
                </div>
              )}
            </li>
          </ul>

          <h2 
            className={`section-title ${visibleSections.works ? 'fade-in visible' : 'fade-in'}`}
            ref={worksRef}
          >
            MY WORKS
          </h2>
          <ul className="animated-list works-list">
            <li 
              onClick={() => handleClick(7)} 
              className={`list-item ${clicked === 7 ? 'expanded' : ''}`}
            >
              {clicked === 7 ? (
                <div className="expanded-content">
                  <span>Developed a Customer Resource Management tool for better customer handling... (proprietary software)</span>
                </div>
              ) : (
                <div className="list-item-content">Customer Resource Management tool (CRM)</div>
              )}
            </li>
            <li 
              onClick={() => handleClick(8)} 
              className={`list-item ${clicked === 8 ? 'expanded' : ''}`}
            >
              {clicked === 8 ? (
                <div className="expanded-content">
                  <span>Integrated many e-commerce API endpoints to facilitate product management, finances, billing... (proprietary software)</span>
                </div>
              ) : (
                <div className="list-item-content">E-Commerce API Endpoint integration </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(9)} 
              className={`list-item ${clicked === 9 ? 'expanded' : ''}`}
            >
              {clicked === 9 ? (
                <div className="expanded-content">
                  <span>Developed a Discord bot with API integration to manage community interactions... (temporarily proprietary software)</span>
                </div>
              ) : (
                <div className="list-item-content">Discord Bot with API integration</div>
              )}
            </li>
            <li 
              onClick={() => handleClick(10)} 
              className={`list-item ${clicked === 10 ? 'expanded' : ''}`}
            >
              {clicked === 10 ? (
                <div className="expanded-content">
                  <span>Built private websites tailored to client needs, with custom functionality / Databases / Design...</span>
                </div>
              ) : (
                <div className="list-item-content">Private Websites on Demand</div>
              )}
            </li>
            <li 
              onClick={() => handleClick(11)} 
              className={`list-item ${clicked === 11 ? 'expanded' : ''}`}
            >
              {clicked === 11 ? (
                <div className="expanded-content">
                  <span>Created a portfolio website to showcase skills and works...</span>
                </div>
              ) : (
                <div className="list-item-content">Portfolio Website</div>
              )}
            </li>
          </ul>

          <h2 
            className={`section-title ${visibleSections.languages ? 'fade-in visible' : 'fade-in'}`}
            ref={languagesRef}
          >
            LANGUAGES
          </h2>
          <ul className="animated-list languages-list">
            <li 
              onClick={() => handleClick(12)} 
              className={`list-item ${clicked === 12 ? 'expanded' : ''}`}
            >
              {clicked === 12 ? (
                <div className="expanded-content">
                  <span>Native speaker of German...</span>
                </div>
              ) : (
                <div className="list-item-content">German (Native)</div>
              )}
            </li>
            <li 
              onClick={() => handleClick(13)} 
              className={`list-item ${clicked === 13 ? 'expanded' : ''}`}
            >
              {clicked === 13 ? (
                <div className="expanded-content">
                  <span>Fluent in English, able to communicate effectively in international settings...</span>
                </div>
              ) : (
                <div className="list-item-content">English (Fluent)</div>
              )}
            </li>
            <li 
              onClick={() => handleClick(14)} 
              className={`list-item ${clicked === 14 ? 'expanded' : ''}`}
            >
              {clicked === 14 ? (
                <div className="expanded-content">
                  <span>Fluent in Russian, native speaker...</span>
                </div>
              ) : (
                <div className="list-item-content">Russian (Native)</div>
              )}
            </li>
          </ul>
        </div>
      </div>


      <div className={`AboutMeSection ${visibleSections.aboutMe ? 'fade-in visible' : 'fade-in'}`}
          ref={aboutMeSectionRef}
        >
          <h2 className="section-title about-me-title">From Hospitality to Code - With People Still at the Center</h2>
          <p className="about-me-text">Coming from a background in hotel management, I discovered my true passion in the world of code. 
            But I've never left behind what the hospitality industry taught me - how to listen, how to understand, and how to deliver experiences that truly resonate.
            Today, I bridge the gap between customers and code. I don't just build what's requested - I make sure the client's vision is translated the right way: 
            with clarity, empathy, and precision. Whether it's a feature, a product, or a full digital experience, 
            I bring both human understanding and technical execution to the table.</p>
          
          <div className="contact-button-container">
            <p className="contact-prompt">Have I piqued your interest?</p>
            <button className="glow-button" onClick={handleContactClick}>
              Contact me, I'll get back to you as soon as I can
            </button>
          </div>
        </div>



      <footer className="footer">
        <div className={`footer-content ${scrollPosition > (document.documentElement.scrollHeight - window.innerHeight - 300) ? 'fade-in visible' : 'fade-in'}`}>
          <p>© 2026 Ron Ellrich | Fullstack Developer & UX/UI Designer</p>
          <button className="scroll-to-top" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            ↑
          </button>
        </div>
      </footer>

      {/* Popup Modal for Contact Form */}
      {showContactPopup && (
        <div className="popup-overlay contact-popup-overlay">
          <div className="popup contact-popup">
            <button className="close-popup" onClick={closeContactPopup}>X</button>
            <Contact />
          </div>
        </div>
      )}

      {/* Popup Modal for Resume Request */}
      {showResumePopup && (
      <ResumePopup onClose={closeResumePopup} />
    )}
    </div>
  );
}

export default Home;